import React from 'react';
// import PropTypes from 'prop-types';
import Accordion from '../AccordionDark';
import Link from '../../Services/ActiveLink'; // our version of link

class NavBarMobile extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div id="selection-bar-virtical">
          <div className="selection-bar-virtical-container">
            <Accordion>
              <div label="Click here for more information">
                <nav className="navigation">
                  <ul className="mainmenu02">
                    <li>
                      <div className="style">
                        <Link href="/testformat" prefetch>
                          <a href="/testformat" className="test-format">
                            Test format and task types
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link href="/science" prefetch>
                          <a href="/science" className="how-to-science">
                            The science behind the test
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link href="/administer" prefetch>
                          <a href="/administer" className="how-to-administer">
                            How to administer the test
                          </a>
                        </Link>
                      </div>
                    </li>

                    <li>
                      <div className="style">
                        <Link href="/results" prefetch>
                          <a href="/results" className="results">
                            How results are presented
                          </a>
                        </Link>
                      </div>
                    </li>

                    <li>
                      <div className="style">
                        <Link href="/practice" prefetch>
                          <a href="/practice" className="practice">
                            Practice materials
                          </a>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="style">
                        <Link href="/testimonials" prefetch>
                          <a href="/testimonials" className="testimonials">
                            Testimonials and case studies
                          </a>
                        </Link>
                      </div>
                      {/* <div className="style">

                        <div className="no-link">
                          View Resources
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="7.41"
                            viewBox="0 0 12 7.41"
                          >
                            <path
                              id="Icon"
                              d="M617.41,2474l4.59-4.58,4.59,4.58,1.41-1.41-6-6-6,6Z"
                              transform="translate(-616 -2466.59)"
                              fill="#ed4236"
                            />
                          </svg>
                        </div>
                  */}
                      {/* </div> */}
                      <ul className="submenu02">
                        <li />
                        <li />
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
              <div label="" />
            </Accordion>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default NavBarMobile;
